import { render, staticRenderFns } from "./Odds.vue?vue&type=template&id=1ae7844a&scoped=true&"
import script from "./Odds.vue?vue&type=script&lang=js&"
export * from "./Odds.vue?vue&type=script&lang=js&"
import style0 from "./Odds.vue?vue&type=style&index=0&id=1ae7844a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7844a",
  null
  
)

export default component.exports